import React, { useState, useEffect, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useAuth } from './AuthContext';
import { ROL_PORTERO } from '../constants/roles';
import { getChequeoProveedoresPendientes, aceptarChequeoProveedores } from '../service/ChequeoProveedoresService';

const POLL_MS = 60000;

// Modal global bloqueante: le pide al Encargado/Guardia que confirme que
// chequeó los proveedores del barrio, cuando el horario configurado para
// ese barrio ya venció hoy y todavía no fue aceptado. No se puede cerrar
// sin aceptar. Si hay varios barrios pendientes, se muestran de a uno.
const ChequeoProveedoresModal = () => {
    const { rolId, administracionId, usuarioId } = useAuth();
    const esPortero = rolId === ROL_PORTERO;

    const [pendientes, setPendientes] = useState([]);
    const [aceptando, setAceptando] = useState(false);

    const fetchPendientes = useCallback(async () => {
        if (!esPortero) return;

        const barriosPermitidos = JSON.parse(localStorage.getItem('barriosPermitidos') || '[]');
        if (barriosPermitidos.length === 0) {
            console.warn('[ChequeoProveedoresModal] no hay barriosPermitidos en localStorage, no se consulta nada');
            return;
        }

        try {
            const { data } = await getChequeoProveedoresPendientes(administracionId, barriosPermitidos);
            console.debug('[ChequeoProveedoresModal] pendientes', { administracionId, barriosPermitidos, data });
            setPendientes(data ?? []);
        } catch (err) {
            // No rompe la navegación del usuario, pero sí queda logueado para poder debuguear.
            console.error('[ChequeoProveedoresModal] error al consultar pendientes', err?.response?.data || err);
        }
    }, [esPortero, administracionId]);

    useEffect(() => {
        if (!esPortero) return;

        fetchPendientes();
        const interval = setInterval(fetchPendientes, POLL_MS);
        return () => clearInterval(interval);
    }, [esPortero, fetchPendientes]);

    if (!esPortero || pendientes.length === 0) return null;

    const pendiente = pendientes[0];

    const aceptar = async () => {
        setAceptando(true);
        try {
            await aceptarChequeoProveedores(pendiente.barrioId, administracionId, usuarioId);
            await fetchPendientes();
        } finally {
            setAceptando(false);
        }
    };

    return (
        <Dialog
            visible
            closable={false}
            dismissableMask={false}
            closeOnEscape={false}
            modal
            style={{ width: '420px' }}
            header="Chequeo de proveedores"
            onHide={() => {}}
        >
            <p style={{ marginTop: 0 }}>
                Recordá revisar los proveedores que están dentro del barrio{' '}
                <b>{pendiente.nombreBarrio}</b> hoy.
            </p>
            <div className="flex justify-content-end mt-3">
                <Button label="Ya lo chequeé" icon="pi pi-check" onClick={aceptar} loading={aceptando} />
            </div>
        </Dialog>
    );
};

export default ChequeoProveedoresModal;
